/**
 * Default fallback data for Kurslederopplæring (Instructor Training).
 * Used for initial seeding or when offline/testing.
 */

export const DEFAULT_INSTRUCTOR_TRAININGS = [
    {
        id: "default-training-2026-autumn",
        title: "Kurslederopplæring høsten 2026",
        subtitle: "Digital kurslederopplæring med oppstart i september 2026",
        format: "digital",
        status: "open",
        instructorName: "Psykologspesialist Serina Vorland",
        location: "Digitalt via Zoom",
        scheduleSummary: "kl. 09.00 til 16.00 hver dag",
        registrationDeadline: "2026-08-24",
        registrationEmail: "post@bekymringsmestring.no",
        infoUrl: "/get-educated",
        price: "Ta kontakt for kursavgift og kommunale avtaler",
        sessions: [
            {
                sessionNumber: 1,
                dates: "7. - 9. september 2026",
                format: "digital",
                notes: "Innføring i metoden, metakognitive og helhetlige modeller, og gruppedynamikk",
            },
            {
                sessionNumber: 2,
                dates: "19. - 21. oktober 2026",
                format: "digital",
                notes: "Praktisk trening, kasus og veiledning på kursledelse",
            },
            {
                sessionNumber: 3,
                dates: "16. november 2026",
                format: "digital",
                notes: "Oppsummering, sertifisering og veien videre",
            },
        ],
        published: true,
        order: 1,
    },
];
